export const FooterENUSTranslations = {
  footerSocialMedia: 'Social Media',
  footerWorkWithUs: 'Work with Us',
  footerContactUs: 'Contact Us',
  footerLinkedinLabel: 'Visit our LinkedIn',
  footerInstagramLabel: 'Visit our instagram',
  footerYoutubeLabel: 'Visit our Youtube',
};
